import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

import { EmployerGroups } from '../core-utils/helper-utils/reportsWorkFlowHelper';
import {
  Features,
  IUserScreenData,
} from '../core-utils/formatters/UserManagementPageFormatter';

export class UserTableStore {
  id: string = '';
  firstName: string = '';
  lastName: string = '';
  emailID: string = '';
  role: string = 'Admin';
  selectedFeatures: Features[] = [];
  employerGroups: EmployerGroups[] = [];
  isEdit: boolean = false;
  screenData: IUserScreenData[] = [];

  constructor() {
    makeObservable(this, {
      id: observable,
      firstName: observable,
      lastName: observable,
      emailID: observable,
      role: observable,
      employerGroups: observable,
      selectedFeatures: observable,
      isEdit: observable,
      screenData: observable,
      setUserTableData: action,
      removeUserTableData: action,
    });

    makePersistable(this, {
      name: 'UserTableStore',
      properties: [
        'id',
        'firstName',
        'lastName',
        'emailID',
        'role',
        'employerGroups',
        'isEdit',
        'selectedFeatures',
        'screenData',
      ],
      storage: window.localStorage,
    });
  }

  setScreenData(screenData: IUserScreenData[]) {
    this.screenData = screenData;
  }

  addUserID(id: string) {
    this.id = id;
  }
  setUserTableData(
    id: string,
    firstName: string,
    lastName: string,
    emailID: string,
    role: string,
    employerGroups: EmployerGroups[],
    isEdit: boolean,
    selectedFeatures: Features[],
  ) {
    this.id = id;
    this.employerGroups = employerGroups;
    this.isEdit = isEdit;
    this.firstName = firstName;
    this.lastName = lastName;
    this.selectedFeatures = selectedFeatures;
    this.emailID = emailID;
    this.role = role;
  }

  removeScreenData() {
    this.screenData = [];
  }
  removeUserTableData() {
    this.id = '';
    this.employerGroups = [];
    this.isEdit = false;
    this.firstName = '';
    this.lastName = '';
    this.emailID = '';
    this.role = 'Admin';
    this.selectedFeatures = [];
  }
}
export default UserTableStore;
